import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import RecentlyReturnedTitle from '../RecentlyReturnedTitle';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { FormattedMessage } from 'react-intl';

import './RecentlyReturnedLoading.scss';

export default class RecentlyReturnedLoading extends BcReactComponent {

  render() {
    return (
      <div className="cp-recentlyreturned">
        <div className="title-row">
          <RecentlyReturnedTitle />
          <div className="recently-returned-loading-panel clearfix">
            <div className="loading-message">
              <FormattedMessage id="recently_returned_loading" />
            </div>
            <div>
              <PrimaryButton handleClick={this.props.retryLoading} className="retry-loading" isLoading={this.props.isLoading}>
                <FormattedMessage id="reload_now" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RecentlyReturnedLoading.propTypes = {
  retryLoading: PropTypes.func,
  isLoading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedLoading/RecentlyReturnedLoading.jsx